export default "__VITE_ASSET__aOws2oRc__ 640w, __VITE_ASSET__B3Oh3D6K__ 1024w, __VITE_ASSET__B2s33Hlh__ 1920w";